import { PaymentMethodEnum, Payment } from "../../../"

export enum PaymentPurposeEnum { // general message to put into the metadata
    FIRST_PAYMENT = "FIRST_PAYMENT",
    BALANCE_PAYMENT = "BALANCE_PAYMENT",
}

export class PaymentInitRequest {
    constructor(
        public amount: number,
        public currency: string,
        public boReference: string,
        public orderId: string,
        public bookingRef: string,
        public email: string,
        public locale: string,
        public system: PaymentMethodEnum,
        public totalPrice: number,
        public stayStartDate: string,
        public stayEndDate: string,
        public purpose: PaymentPurposeEnum,
        public company: string | undefined,
        public cardHolderName: string,
        public user_id: string,
        public payments?: Payment[]
    ) { }
}